// extracted by mini-css-extract-plugin
module.exports = {"closeIframeBtnWrapper":"styles_closeIframeBtnWrapper__3WTp5","closeIframeBtn":"styles_closeIframeBtn__3CT8m","iframe":"styles_iframe__Ajxp_"};